<template>
    <div
        class="selection-row"
        :class="{ 'selection-row--special': isSpecialType }"
    >
        <div class="selection-row__wrapper">
            <EventSummary
                :isLive="event.isLive"
                :startDate="event.date"
                :team1Name="event.team1Name || displayName || event.name"
                :team2Name="event.team2Name || ''"
                :result="event.result"
            />
        </div>
        <div class="selection-row__controls">
            <i v-if="isSpecialType" class="icon icon-special" />
            <div v-if="event.wasLive">
                <span class="event-summary__match-indicator-live event-summary__match-indicator-live--before">
                    <span class="event-summary__match-indicator-live-dot"></span>
                    <span class="event-summary__match-indicator-live-text">
                        {{ $t('live bet') | capitalize }}
                    </span>
                </span>
            </div>
        </div>
        <div
            class="selection-row__bet"
            :class="statusClass"
        >
            <div class="selection-row__market-box">
                <span
                    v-if="event.eventNo"
                    class="selection-row__system-info"
                >
                    {{ event.eventNo }}
                </span>
                <span class="selection-row__fix-switch">
                    <slot />
                </span>
                <span
                    class="selection-row__market-name"
                    :title="marketName"
                >
                    {{ marketName }}
                </span>
            </div>
            <button class="pick">
                <span
                    class="market actionable"
                    :title="odd.symbol"
                >
                    {{ odd.symbol }} {{ odd.specialBetValue ? `(${odd.specialBetValue})` : '' }}
                </span>
                <span class="odd">
                    <span
                        v-if="isRefund"
                        class="odd--refunded"
                    >
                        {{ odd.value | twoDecimals }}
                    </span>
                    <template v-if="isRefund">1</template>
                    <template v-else>{{ odd.value | twoDecimals }}</template>
                </span>
            </button>
        </div>
    </div>
</template>

<script>
    import BetSlipHelper from '@store/modules/ui/shared/betSlip/Helpers';
    import EventSummary from '@modules/shared/event/EventSummary.vue';
    import { EventStatus } from '@core/models/tickets/enums';

    export default {
        name: 'Selection',
        props: {
            isSpecialType: {
                type: Boolean,
                default: false,
            },
            event: {
                type: Object,
                required: true,
            },
            odd: {
                type: Object,
                required: true,
            },
            displayName: {
                type: String,
                default: null,
            },
            marketName: {
                type: String,
                default: '',
            }
        },
        methods: {
            getErrorMessage(error) {
                return this.$t(
                    BetSlipHelper.getBetSlipErrorMessageTemplate(error),
                    error.params
                );
            },
        },
        computed: {
            statusClass() {
                switch (this.event.status) {
                    case EventStatus.win:
                        return 'selection-row__bet--won';
                    case EventStatus.lost:
                        return 'selection-row__bet--lost';
                    case EventStatus.refund:
                        return 'selection-row__bet--refund';
                    default:
                        return '';
                }
            },
            isRefund() {
                return this.event.status === EventStatus.refund;
            },
        },
        components: {
            EventSummary,
        },
    };
</script>

<style>
    .error {
        font-size: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/app/modules/shared/tickets/SelectionReadOnly.vue